import "../shared/codeload.js";
import "../analytics/index.js";
import "../embed/index.js";
import "../embed/utilities/url_modifier.js";
import "../embed/utilities/browser.js";
import "../embed/utilities/translation_observer.js";

window.Sparkle ??= {};

Sparkle.Snippet = {
  Container: {
    prepare: function (selector, urlMap) {
      window.ModalDefaults = {
        appendTo: selector,
      };

      if (Sparkle.Embed.Utilities.isEdge()) {
        Sparkle.Embed.Utilities.TranslationObserver.observe(selector);
      }

      Sparkle.Embed.Utilities.decorateEmbeddedHrefs(selector, { urlMap: urlMap });

      return jQuery(selector);
    },
  },
};
